module.exports = __webpack_public_path__ + "static/media/Credencial_FUAR.2db70269.gif";